import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPasswordLayer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/backend/users/forget-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      
      if (response.ok) {
        toast.success("Password reset link sent to your email. Please check your inbox.");
        setEmailSent(true);
      } else {
        toast.error(data.message || "Failed to send reset link. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth-container">
      <ToastContainer />
      
      <div className="frosted-glass-card">
        <div className="card-content">
          <Link to="/" className="logo-link">
            <div className="flex items-center">
              <img
                src="assets/images/logo_fw.png"
                alt="Logo"
                className="logo-image"
              />
            </div>
          </Link>
          <h4 className="card-title">Forgot Password</h4>
          <p className="card-subtitle">
            {emailSent 
              ? "Password reset link sent to your email. Please check your inbox."
              : "Enter your email to receive a password reset link"}
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-field">
              <span className="form-icon pb-3">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-input"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={emailSent}
              />
            </div>
            
            <button
              type="submit"
              className="submit-button text-center"
              disabled={loading || emailSent}
            >
              {loading ? (
                <span className="spinner" role="status" aria-hidden="true"></span>
              ) : (
                emailSent ? "Email Sent" : "Send Reset Link"
              )}
            </button>
          </form>

          <div className="auth-footer mt-40">
            <Link to="/sign-in" className="auth-footer-link text-success-700">
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordLayer;